import { Injectable } from '@angular/core';

import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class AbilityService {
  constructor(private sessionService: SessionService) {}

  can(action) {
    let data = this.sessionService.getCurrentUser();

    if (!data) return false;

    let currentUser = data.user_info;

    let canAccess = false;

    if (Array.isArray(action)) {
      canAccess = this.listOfPermissions(currentUser, action);
    } else {
      if (currentUser && currentUser.role_info && currentUser.role_info.permissions[action]) {
        canAccess = true;
      }
    }

    return canAccess;
  }

  canFeature(feature, totalResourcesConsumed = 0) {
    let data = this.sessionService.getCurrentUser();

    if (!data) {
      // return false;
      return { permitted: false };
    }

    let currentUser = data.user_info;
    let currentAccount = currentUser.account_info;

    let canAccess = {
      permitted: false,
      name: '',
      type: '',
      visible_as_addon: false,
      totalResourcesConsumed: 0,
      totalResouresPermitted: 0,
    };

    if (currentUser && !currentUser.sd) {
      // AccountAdmin
      for (let i = 0; i < currentAccount.account_plan_features.length; i++) {
        let accountPlanFeature = currentAccount.account_plan_features[i];

        canAccess = {
          permitted: false,
          name: '',
          type: '',
          visible_as_addon: false,
          totalResourcesConsumed: 0,
          totalResouresPermitted: 0,
        };

        if (accountPlanFeature.feature.name_key === feature) {
          if (accountPlanFeature.feature.type === 'available' && !accountPlanFeature.available) {
            canAccess.permitted = false;
          } else {
            canAccess.name = accountPlanFeature.feature.name;
            canAccess.type = accountPlanFeature.feature.type;
            canAccess.visible_as_addon = true;

            let totalResouresPermitted =
              accountPlanFeature.total_units + this.getTotalAddonResources(currentAccount, feature);

            canAccess.totalResourcesConsumed = totalResourcesConsumed;
            canAccess.totalResouresPermitted = totalResouresPermitted;

            canAccess.permitted =
              totalResourcesConsumed < totalResouresPermitted ||
              totalResourcesConsumed === undefined
                ? true
                : false;
          }

          break;
        }
      }
    } else {
      canAccess.permitted = true; // temporary beacuse we need to canfeature master user roles
    }

    return canAccess;
  }

  private getTotalAddonResources(currentAccount, feature) {
    let totalUnits = 0;

    for (let i = 0; i < currentAccount.account_plan_addons.length; i++) {
      let accountPlanAddon = currentAccount.account_plan_addons[i];

      // Only active addons -  && accountPlanAddon.status
      if (accountPlanAddon.feature.name_key === feature) {
        totalUnits = totalUnits + accountPlanAddon.total_units;
      }
    }

    return totalUnits;
  }

  // check user action
  private listOfPermissions(currentUser, actions) {
    let canAccess = false;

    actions.map(function (action) {
      if (currentUser.role_info.permissions[action]) {
        canAccess = true;
      }
    });

    return canAccess;
  }
}
